import { Component, h } from 'preact';
import cx from 'classnames';
import { HopplerModal } from "./hoppler-modal-component";

interface HopplerModalizerProps {
  onClose: () => void;
  extraClasses?: string;
}
interface HopplerModalizerState {}

export class HopplerModalizer extends HopplerModal<HopplerModalizerProps, HopplerModalizerState> {
  doModalClose() {
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    return this.modalize(
      <div className={ cx('hi-modalizer', this.props.extraClasses) }>
        { this.props.children }
      </div>
    )
  }
}
